/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Typography,
  Link,
} from '@one-thd/sui-atomic-components';

import { editMeasure } from '../../actions';
import { scheduleMeasureUrlSelector } from '../../selectors/scheduleMeasureUrl';
import FlooringCard from '../../components/accordion/index';
import AddRoom from '../../components/addRooms';
import Measures from '../../components/measures';
import MeasuringTipsDrawer from '../../components/MeasuringTipsDrawer';
import StairCase from '../../components/StairCase/index';
import { openOverlaySelector, roomMeasureSelector } from '../../selectors/roomMeasure';
import { UpdateRoom } from '../../components/overlay';
import { canContinueSelector, stepsSelector } from '../../selectors/steps/steps';
import {
  firstNoLinkText,
  extractLinkText,
  lastNoLinkText,
} from '../../utils/extractText';
import { linkStart } from '../../utils/boldCovention';
import { customTags } from '../../utils/tags/customTags';
import { trackMeasuringTips, trackNavigationLinkTracking } from '../../utils/analytics/trackEvents';
import {
  Description,
  DescriptionContainer,
  MeasuringTipsLinkContainer,
  RoomGridTitleWrapper,
  RoomGrids,
  RoomTitleWrapper,
  AddRoomButtonWrapper
} from './styles';

function Flooring(props) {
  const [roomInfo, setTags] = useState({});
  const [showMeasuringTipsDrawer, setShowMeasuringTipsDrawer] = useState(false);
  const selector = useSelector(openOverlaySelector);
  const { measure } = useSelector(roomMeasureSelector);

  const [showAddRoomModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { samUrl } = useSelector(scheduleMeasureUrlSelector);
  const canContinue = useSelector(canContinueSelector);
  const { steps } = useSelector(stepsSelector);

  useEffect(() => {
    setTags(customTags(props.option.tags));
  }, []);

  const handleAddRoom = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleEditModal = () => {
    dispatch(editMeasure(false));
  };

  const openDrawer = () => {
    setShowMeasuringTipsDrawer(true);
    trackMeasuringTips();
  };
  const closeDrawer = () => setShowMeasuringTipsDrawer(false);

  return (
    <>
      <FlooringCard title={props.option.shortLabel} testId="enter-rooms">
        <div className="description-container">
          <p className="enter-rooms-description">
            {props.option.longLabel.includes(linkStart) ? (
              <>
                <p>
                  {firstNoLinkText(props.option.longLabel)}
                  <Link
                    href={samUrl}
                    rel="noreferrer"
                    target="_blank"
                    underline="always"
                    onClick={() => trackNavigationLinkTracking(
                      'Room Description', 'Schedule an in-home carpet measure ')}
                  >
                    {extractLinkText(props.option.longLabel)}
                  </Link>
                  {lastNoLinkText(props.option.longLabel)}
                </p>
              </>
            ) : (<p>{props.option.longLabel}</p>)}
          </p>
          <div className="measuring-tipsLink-container">
            <Typography decoration="underline" onClick={openDrawer}>
              Measuring Tips
            </Typography>
          </div>
        </div>
        <div className="room-grid-title-wrapper">
          <div className="room-title-wrapper">
            <Typography variant="h4">My Rooms</Typography>
          </div>
          {measure.length ?
            (
              <RoomGrids>
                <Measures />
              </RoomGrids>
            )
            : null}
        </div>
        <div className="add-room-button-wrapper">
          <Button
            fullWidth
            variant={measure.length || canContinue || steps ? 'secondary' : 'primary'}
            onClick={handleAddRoom}
          >
            Add a Room
          </Button>
        </div>
        {selector.isOpenOverlay && (
          <UpdateRoom
            isOpen={selector.isOpenOverlay}
            roomName={roomInfo.roomName}
            roomLength={roomInfo.roomLength}
            roomWidth={roomInfo.roomWidth}
            UpdatedLengthPlaceHolder={roomInfo.lengthPlaceHolder}
            updatedWidthPlaceHolder={roomInfo.widthPlaceHolder}
            updatedNamePlaceholder={roomInfo.roomNamePlaceHolder}
            onHandleClose={handleEditModal}
          />
        )}
        {!selector.isOpenOverlay && (
          <AddRoom
            showModal={showAddRoomModal}
            handleClose={handleClose}
            roomName={roomInfo.roomName}
            roomLength={roomInfo.roomLength}
            roomWidth={roomInfo.roomWidth}
            roomLengthPlaceholder={roomInfo.lengthPlaceHolder}
            roomWidthPlaceholder={roomInfo.widthPlaceHolder}
            roomNamePlaceholder={roomInfo.roomNamePlaceHolder}
            isEdit={false}
            onChoiceSelected={props.onChoiceSelected}
            option={props.option}
          />

        )}
        <StairCase />
      </FlooringCard>
      <MeasuringTipsDrawer showDrawer={showMeasuringTipsDrawer} closeDrawer={closeDrawer} />

    </>
  );
}

Flooring.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number.isRequired,
    shortLabel: PropTypes.string.isRequired,
    longLabel: PropTypes.string.isRequired,
    tags: PropTypes.array.isRequired,
  }).isRequired,
  onChoiceSelected: PropTypes.func.isRequired,
};

export default Flooring;
